import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { useNetworkTracking } from '@xing-com/crate-network-tracking';
import { useLoginAppUrl } from '@xing-com/crate-xinglet';

import { Styled } from './hiring-section.styled';

export const HiringSection: FC = () => {
  const { trackNetworkNWTExtended } = useNetworkTracking();
  const loginUrl = useLoginAppUrl();

  const ctaLinkTracking =
    '?sc_o=contacts_network_hiring_register_click&signup_channel=minireg_network_hiring';
  const destParam =
    '&dest_url=' +
    encodeURIComponent(
      '/profile/my_profile/hiring-details/edit?origin=network'
    );
  const buttonUrl = loginUrl + ctaLinkTracking + destParam;

  const onClickCta = (): void => {
    trackNetworkNWTExtended({
      event: 'opened',
      element: 'register',
      elementDetail: 'hiring',
      moduleTitle: 'hiring',
    });
  };

  return (
    <Styled.CustomSection data-qa="hiring-section">
      <Styled.GridContainerBackground
        variant="expanded"
        data-qa="hiring-container"
      >
        <Styled.GridItemContainer>
          <Styled.HeadlineWide size="small">
            <FormattedMessage id="NETWORK_LOGGED_OUT_HIRING_HEADLINE" />
          </Styled.HeadlineWide>
          <Styled.HeadlineSmall size="xxlarge">
            <FormattedMessage id="NETWORK_LOGGED_OUT_HIRING_HEADLINE" />
          </Styled.HeadlineSmall>
          <Styled.Subline size="medium" sizeConfined="large">
            <FormattedMessage id="NETWORK_LOGGED_OUT_HIRING_SUBLINE" />
          </Styled.Subline>
          <Styled.HiringButton
            variant="tertiary"
            size="large"
            to={buttonUrl}
            onClick={onClickCta}
          >
            <FormattedMessage id="NETWORK_LOGGED_OUT_HIRING_CTA" />
          </Styled.HiringButton>
        </Styled.GridItemContainer>
      </Styled.GridContainerBackground>
    </Styled.CustomSection>
  );
};
